//create arrow position

const form = document.querySelector('form');

if (form) {
const formInputs = form.querySelectorAll('input');
const selects = form.querySelectorAll('select');
const arrow = form.querySelectorAll('.arrow-lr');


		for (let i = 0; i < selects.length; i++) {
				selects[i].addEventListener('focus', function () {
						let inputOffsetTop = this.offsetTop;

						for (let i = 0; i < arrow.length; i++) {
								arrow[i].style.top = (inputOffsetTop + 10) + 'px';
						}
				});
		}

		for (let i = 0; i < formInputs.length; i++) {
				formInputs[i].addEventListener('focus', function () {
						
						let inputType = this.type;
						let inputOffsetTop = this.offsetTop;

						if (inputType === "checkbox") {
								for (let i = 0; i < arrow.length; i++) {
										arrow[i].style.top = (inputOffsetTop) + 'px';
								}

						} else {
								for (let i = 0; i < arrow.length; i++) {
										arrow[i].style.top = (inputOffsetTop + 10) + 'px';
								}
						}
				});
		}
}

